module.exports = __webpack_public_path__ + "img/poster_count_gq.436270ed.png";